var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKucoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5775",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 536.8 586.9",
    width: 2287,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#0097e8}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6382",
    transform: "matrix(.847 0 0 .847 102.755 165.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect6336",
    className: "st0",
    d: "M-62.5-137.3c32.5 0 58.9 26.4 58.9 58.9v457.7c0 32.5-26.4 58.9-58.9 58.9s-58.9-26.4-58.9-58.9V-78.4c.1-32.5 26.4-58.9 58.9-58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6338",
    className: "st0",
    d: "M317.8-172.9c22.9 23.1 22.7 60.4-.4 83.2L-8 232.3c-23.1 22.9-60.4 22.7-83.2-.4-22.9-23.1-22.7-60.4.4-83.2l325.4-321.9c23.1-23 60.4-22.8 83.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6340",
    className: "st0",
    d: "M317.8 473.4c22.9-23.1 22.7-60.4-.4-83.2L-8 68.3c-23.1-22.9-60.4-22.7-83.2.4-22.9 23.1-22.7 60.4.4 83.2l325.4 321.9c23.1 23 60.4 22.8 83.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6361-4",
    className: "st0",
    d: "M495.3 226.3c22.9 23.1 22.8 60.4-.2 83.3L323.9 480c-23.1 22.9-60.4 22.8-83.3-.2-22.9-23.1-22.8-60.4.2-83.3L412 226.1c23-22.9 60.3-22.8 83.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6378",
    className: "st0",
    d: "M495.3 75c22.9-23.1 22.8-60.4-.2-83.3L323.9-178.7c-23.1-22.9-60.4-22.8-83.3.2-22.9 23.1-22.8 60.4.2 83.3L412 75.2c23.1 22.9 60.4 22.9 83.3-.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path6380",
    className: "st0",
    cx: 282.7,
    cy: 150.7,
    r: 59.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoin);
export default __webpack_public_path__ + "static/media/kucoin.33d322e79d43c3a9c32238f05251dfd3.svg";
export { ForwardRef as ReactComponent };